<app-section-layout [dataForChart]="graphData" [itemTemplate]="sbuGraph"></app-section-layout>

<ng-template #sbuGraph let-data="data">
    <app-vertical-bar-graph [graph]="data.graph.data[0]"></app-vertical-bar-graph>
</ng-template>